export var SENTRY_RELEASE = "fafe7d8d901c11ad56d6c3efccb7e3291d8ceaf5";
